const actionTypes = {
  SetExportData: 'exporter/SET_EXPORT_DATA',
  SetExportSorts: 'exporter/SET_EXPORT_SORTS',
  SetExportFilters: 'exporter/SET_EXPORT_FILTERS',
}

const initialState = {
  outputs: [], // array of data outputs
  from: null, // pdf, what function to utilize via "STRING_TYPE" ie "DISCOVERY", "REPORTING" etc
  sorts: {},
  filters: {},
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SetExportData:
      return { ...state, ...action.payload.exportData }
    case actionTypes.SetExportSorts:
      return { ...state, ...action.payload.sorts }
    case actionTypes.SetExportFilters:
      return { ...state, ...action.payload.filters }
    default:
      return state
  }
}

export const actions = {
  setExportData: (exportData) => ({
    type: actionTypes.SetExportData,
    payload: { exportData },
  }),
  setExportSortsData: (sorts) => ({
    type: actionTypes.SetExportSorts,
    payload: { sorts },
  }),
  setExportFiltersData: (filters) => ({
    type: actionTypes.SetExportFilters,
    payload: { filters },
  }),
}
